<template>
    <div>
        <!--  FAKE CALL TO POPULATE INITIAL VALUES -->
        {{populateInitialValues}}
            <b-container>
                <transition name="fade">
                <div v-if="showSuccess" class="loading">
                    <p>Updating</p>
                </div>
                </transition>

                <!-- Transition to check address -->
                <transition name="fade">
                <div v-if="checkingAddress" class="loading">
                    <p>Checking Your Address</p>
                </div>
                </transition>

                <!-- Transition to upload image -->
                <transition name="fade">
                <div v-if="addingLicense" class="loading">
                    <p>Uploading Image</p>
                </div>
                </transition>


            <h3>Settings</h3>
            <!-- Modal to show matching address -->
            <b-row>
                <b-col>
                    <b-modal no-fade size="l" id="modal-newaddress" title="We Found a Matching Address" 
                    ok-title="Yes, Update"  @ok="updateAddress()">
                            <template v-slot:default="{ hide }">
                                <p>{{validatedAddress.street1}}</p>
                                <p>{{validatedAddress.street2}}</p>
                                <p>{{validatedAddress.zip}}</p>
                            </template>
                    </b-modal>
                </b-col>
            </b-row>

            <!-- Incorrect address modal -->
            <b-row>
                <b-col>
                    <b-modal no-fade size="l" id="modal-invalidaddress" ok-only title="This Does Not Seem To Be a Valid Address" >
                        Please check the address and try again
                    </b-modal>
                </b-col>
            </b-row>


            <b-row>
                <b-col>
                    <!-- Company name, don't allow change if rep -->
                    <div>
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Profile'
                        >
                            <b-input-group prepend="Company" class="mt-3">
                                <b-form-input v-model="company" :placeholder="userProfile.company"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group prepend="Phone" class="mt-3">
                                <b-form-input v-model="phone" :placeholder="userProfile.phone"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group prepend="Contact Name" class="mt-3">
                                <b-form-input v-model="contactname" :placeholder="userProfile.contactname"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button style="margin-top:10px" variant="info" @click="updateName()" >Update</b-button>
                        </b-card>
                    </div>
                    <!-- Additional order emails -->
                    <div v-if="!(this.userProfile.isbrewer==10)">
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Additional Order Emails'
                        >
                        {{this.currentUser.email}}
                            <b-input-group prepend="Email1" class="mt-3">
                                <b-form-input v-model="email1" ></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group prepend="Email2" class="mt-3">
                                <b-form-input v-model="email2" ></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group prepend="Email3" class="mt-3">
                                <b-form-input v-model="email3" ></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button style="margin-top:10px" variant="info" @click="updateAdditionalEmails()">Update Emails</b-button>
                        </b-card>
                    </div>

                    <!-- Services offered -->
                    <b-card v-if="userProfile.isbrewer==1" bg-variant="light"  border-variant="secondary" class="mb-2" title='Services Offered'>
                        <hr>
                        <b-row>
                            <b-col>
                                Line Cleaning
                            </b-col>
                            <b-col>
                                <b-button @click="changeServices('linecleaningenabled', 2)" v-if="(!userProfile.linecleaningenabled)||userProfile.linecleaningenabled==1">Disable</b-button>
                                <b-button v-else variant="info" @click="changeServices('linecleaningenabled', 1)">Enable</b-button>
                                
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row style="margin-top:5px">
                            <b-col>
                                Keg Pick Up
                            </b-col>
                            <b-col>
                                <b-button @click="changeServices('kegpickupenabled', 2)" v-if="(!userProfile.kegpickupenabled)||userProfile.kegpickupenabled==1">Disable</b-button>
                                <b-button v-else variant="info" @click="changeServices('kegpickupenabled', 1)">Enable</b-button>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row style="margin-top:5px">
                            <b-col>
                                Tap Handles
                            </b-col>
                            <b-col>
                                <b-button @click="changeServices('taphandlesenabled', 2)" v-if="(!userProfile.taphandlesenabled)||userProfile.taphandlesenabled==1">Disable</b-button>
                                <b-button v-else variant="info" @click="changeServices('taphandlesenabled', 1)">Enable</b-button>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row style="margin-top:5px">
                            <b-col>
                                Signage
                            </b-col>
                            <b-col>
                                <b-button @click="changeServices('signageenabled', 2)" v-if="(!userProfile.signageenabled)||userProfile.signageenabled==1">Disable</b-button>
                                <b-button v-else variant="info" @click="changeServices('signageenabled', 1)">Enable</b-button>
                            </b-col>
                        </b-row>
                    </b-card>

                    <!-- ABC License Number -->
                    <div v-if="!(this.userProfile.isbrewer==10)">
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='ABC License Number'
                        >
                            <b-input-group prepend="License Number" class="mt-3">
                                <b-form-input v-model="abcLicenseNumber" :placeholder="userProfile.abcLicenseNumber"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button style="margin-top:10px" variant="info" @click="updateabcLicenseNumber()" :disabled='!checkabcLicenseNumber'>Update ABC License Number</b-button>
                        </b-card>
                    </div>
                    
                    <!-- Delivery Method -->
                    <div v-if='userProfile.isbrewer&&!(this.userProfile.isbrewer==10)'>
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Distribution Method'
                        >
                        <div>
                            <b-dropdown style="margin-bottom:10px" variant='dark' id="dropbowndelselect" text="Select A Distribution Method">
                                <b-dropdown-item  v-for="(deliveryAgent) in getDeliveryAgents" :key="deliveryAgent" @click="deliveryMethod=deliveryAgent">{{deliveryAgent}}</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button  v-b-modal.modalmoremethods >Other</b-dropdown-item-button>
                            </b-dropdown>
                            <h5>{{theDeliveryMethod}}</h5>
                                <b-modal no-fade id= "modalmoremethods"  title="Other delivery method" ok-only ok-title="OK"  @ok="deliveryMethod=otherDeliveryMethod">
                                <b-form-group
                                    class="mb-0"
                                    label-for="textarea-formatter-delivery"
                                    
                                >
                                <b-form-textarea
                                    id="textarea-formatter-delivery"
                                    v-model="otherDeliveryMethod"                    
                                ></b-form-textarea>
                            </b-form-group>
                                                
                            </b-modal>
                            <b-button style="margin-top:10px" variant="info" @click="setDeliveryMethod()"> Update Distribution Method</b-button>
                    </div>

                        </b-card>
                    </div>

                    <!-- Address update card -->
                    <div>
                        <b-card  v-if="!(this.userProfile.isbrewer==10)"
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Address'
                        >

                            <b-input-group prepend="Street 1" class="mt-3">
                                <b-form-input v-model="street1" :placeholder="userProfile.street1"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group prepend="Street 2" class="mt-3">
                                <b-form-input v-model="street2" :placeholder="userProfile.street2"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group prepend="Zip" class="mt-3">
                                <b-form-input maxlength="5"  v-model="zip" :placeholder="userProfile.zip"></b-form-input>
                            </b-input-group>

                            <b-button style="margin-top:10px" variant="info" @click="checkAddress()" :disabled="!checkZipLength||!checkAddressLength" class="button">Update Address</b-button>
                        </b-card>

                        <!-- Delivery Counties -->
                        <b-card v-if="userProfile.isbrewer==1||userProfile.isbrewer==2"
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Delivery Counties'>
                        <small>*Choose counties to deliver.</small>
                        <div v-for ="county in userProfile.counties" :key="county">
                            {{county}}
                        </div>
                        <b-button style="margin-top:10px" variant="info" v-b-modal.countieslist class="button">Update Counties</b-button>

                        </b-card>

                        <b-modal no-fade  scrollable size="xl" id= "countieslist" title="Select Counties" ok-only ok-variant="secondary" 
                        ok-title="Close" hide-footer @ok = "updateCounties()"
                        
                        >
                            <template v-slot:modal-header="{ close, ok }">
                                <!-- Emulate built in modal header close button action -->
                                <h5>Select Counties</h5>
                                <b-button variant="success" @click="ok()">
                                    Update
                                </b-button>
                                <b-button variant="outline-danger" @click="close()">
                                    Close
                                </b-button>
                            </template>

                        <div v-for="(county, index) in getCounties" :key="county.name">
                            <div v-if="county.isSelected">
                                <b-button :pressed="true" variant="warning" @click="removeCountyFromList(county.name)">{{county.name}}<font-awesome-icon icon="times" /></b-button>
                            </div>
                            <div v-else>
                                <b-button variant="success" @click="addToCountyList(county.name, index)">{{county.name}}</b-button>
                            </div>
            
                            <hr>
                        </div>
                        <hr>
                        </b-modal>
                        <!-- End Of Delivery Counties -->

                        <!-- Delivery instructions from buyers -->
                        <b-card  v-if='userProfile.isbrewer<=0'
                            bg-variant="light" 
                            border-variant="secondary"
                            class="mb-2"
                            title='Delivery Instructions'>
                            
                            <b-form-group  v-if='userProfile.isbrewer<=0'
                                class="mb-0"
                                label-for="textarea-formatter-delivery"
                                description="Add delivery instructions for breweries"
                                >
                                <b-form-textarea
                                    id="textarea-formatter-delivery"
                                    v-model="deliveryInstructions"
                                    :placeholder="userProfile.deliveryInstructions"
                                ></b-form-textarea>
                            </b-form-group>
                            <b-button  variant="info" @click="updateInstructions()" class="button">Update Instructions</b-button>
                        </b-card>

                        <!-- Change user credentials -->
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Credentials'
                        >
                            <!-- Don't allow reps to change email -->
                            <b-input-group v-if="!(this.userProfile.isbrewer==10)" prepend="New Email" class="mt-3">
                                <b-form-input v-model="newEmail" type=email :placeholder="this.currentUser.email"></b-form-input>
                                <b-input-group-append>
                                    <b-button v-b-modal.modal-email :disabled='!checkEmailValid' >Update Email</b-button>
                                        <b-modal id="modal-email"  :ok-title ='"Change email to "+newEmail' title="Re enter OLD email and password" @ok="reAuthUser(0)">
                                            <b-form-input v-model="loginForm.email" placeholder="Old Email"></b-form-input>
                                            <b-form-input type='password' v-model="loginForm.password" placeholder="Password"></b-form-input>
                                        </b-modal>
                                </b-input-group-append>
                            </b-input-group>

                            <!-- Password -->
                            <b-input-group prepend="New Password" class="mt-3">
                                <b-form-input v-model="newPassword" type=password ></b-form-input>
                                
                                <b-input-group-append>
                                    <b-button v-b-modal.modal-password :disabled="!checkPasswordValid">Update Password</b-button>
                                        <b-modal id="modal-password"  ok-title ='Update Password' title="Re enter email and password" @ok="reAuthUser(1)">
                                            <b-form-input v-model="loginForm.email" placeholder="Email"></b-form-input>
                                            <b-form-input type='password' v-model="loginForm.password" placeholder="Old Password"></b-form-input>
                                        </b-modal>
                                </b-input-group-append>
                                <div><small>Password must be at least 8 characters</small></div>
                            </b-input-group>
                        </b-card>

                        <br>
                        <!-- Desription -->
                        <b-card  v-if='userProfile.isbrewer&&!(this.userProfile.isbrewer==10)'
                            bg-variant="light" 
                            border-variant="secondary"
                            class="mb-2"
                            title='About Your Brewery'>
                            <b-form-group  v-if='userProfile.isbrewer'
                                class="mb-0"
                                label-for="textarea-formatter"
                                description="Say something about your brewery"
                                >
                                <b-form-textarea
                                    id="textarea-formatter"
                                    v-model="description"
                                    :placeholder="userProfile.description"
                                ></b-form-textarea>
                            </b-form-group>
                            <b-button  variant="info" @click="updateDescription()" class="button">Update Description</b-button>
                        </b-card>

                        <!-- Email Preferences -->
                        <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Email Preferences'
                        >
                        {{returnEmailPrefs}}

                            <b-form-checkbox 
                                id="checkbox-1"
                                v-model="allowOrderEmails"
                                name="checkbox-1"
                                value="yes"
                                unchecked-value="no"
                                >
                                Send me order update emails
                                </b-form-checkbox>

                                <b-form-checkbox
                                id="checkbox-2"
                                v-model="allowMarketingEmails"
                                name="checkbox-2"
                                value="yes"
                                unchecked-value="no"
                                >
                                Send me the very occasional marketing emails
                                </b-form-checkbox>
                                <br>
                                <b-button  variant="info" @click="updateEmailPreferences()" class="button">Update Email Preferences</b-button>


                        </b-card>
                            
                    </div>

                </b-col>
                <!-- License File -->
                <b-col>
                    <b-card 
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='License File'
                        >
                        <form>
                            <div class="form-group">
                                <img :src="userProfile.licenseFileThumbnailURL" fluid alt="License image" id='licenseimg'>
                            </div>
                            <div class="form-group">
                                <input id="image-file-license" type="file" class="form-control-file"  @change="onLicenseFileChanged"/>
                            </div>
                        </form>

                    </b-card>

                    <!-- Logo Image -->
                    <b-card 
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Logo'
                        >
                        <form>
                            <div class="form-group">
                                <img :src="userProfile.logoFileThumbnailURL" fluid alt="Logo image">
                            </div>
                            <div class="form-group">
                                <input id="image-file-logo" type="file"  class="form-control-file"  @change="onLogoFileChanged"/>
                            </div>
                        </form>

                    </b-card>

                </b-col>
            </b-row>

            </b-container>
            <footer><pagefooter/></footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';
    //import cloudinary from 'cloudinary-core';    // If your code is for ES6 or higher
    import axios from 'axios'
    import Pagefooter from './Pagefooter'
    import { log } from 'util';
    import { SSL_OP_NETSCAPE_CA_DN_BUG } from 'constants';
    import { usStates } from './Myfunctions'
    import { checkAddress } from './Myfunctions'
    import { deliveryAgents } from './Myfunctions'


    import { alabamaCountiesList } from '../counties/alabama'
    import { alaskaCountiesList } from '../counties/alaska'
    import { arizonaCountiesList } from '../counties/arizona'
    import { arkansasCountiesList } from '../counties/arkansas'
    import { californiaCountiesList } from '../counties/california'
    import { coloradoCountiesList } from '../counties/colorado'
    import { connecticutCountiesList } from '../counties/connecticut'
    import { delawareCountiesList } from '../counties/delaware'
    import { floridaCountiesList } from '../counties/florida'
    import { georgiaCountiesList } from '../counties/georgia'
    import { hawaiiCountiesList } from '../counties/hawaii'
    import { idahoCountiesList } from '../counties/idaho'
    import { illinoisCountiesList } from '../counties/illinois'
    import { indianaCountiesList } from '../counties/indiana'
    import { iowaCountiesList } from '../counties/iowa'
    import { kansasCountiesList } from '../counties/kansas'
    import { kentuckyCountiesList } from '../counties/kentucky'
    import { louisianaCountiesList } from '../counties/louisiana'
    import { maineCountiesList } from '../counties/maine'
    import { marylandCountiesList } from '../counties/maryland'
    import { massachussettsCountiesList } from '../counties/massachussetts'
    import { michiganCountiesList } from '../counties/michigan'
    import { minnesotaCountiesList } from '../counties/minnesota'
    import { mississippiCountiesList } from '../counties/mississippi'
    import { missouriCountiesList } from '../counties/missouri'
    import { montanaCountiesList } from '../counties/montana'
    import { nebraskaCountiesList } from '../counties/nebraska'
    import { nevadaCountiesList } from '../counties/nevada'
    import { newhampshireCountiesList } from '../counties/newhampshire'
    import { newjerseyCountiesList } from '../counties/newjersey'
    import { newmexicoCountiesList } from '../counties/newmexico'
    import { newyorkCountiesList } from '../counties/newyork'
    import { northcarolinaCountiesList } from '../counties/northcarolina'
    import { northdakotaCountiesList } from '../counties/northdakota'
    import { ohioCountiesList } from '../counties/ohio'
    import { oklahomaCountiesList } from '../counties/oklahoma'
    import { oregonCountiesList } from '../counties/oregon'
    import { pennsylvaniaCountiesList } from '../counties/pennsylvania'
    import { rhodeislandCountiesList } from '../counties/rhodeisland'
    import { southcarolinaCountiesList } from '../counties/southcarolina'
    import { southdakotaCountiesList } from '../counties/southdakota'
    import { tennesseeCountiesList } from '../counties/tennessee'
    import { texasCountiesList } from '../counties/texas'
    import { utahCountiesList } from '../counties/utah'
    import { vermontCountiesList } from '../counties/vermont'
    import { virginiaCountiesList } from '../counties/virginia'
    import { washingtonCountiesList } from '../counties/washington'
    import { westvirginiaCountiesList } from '../counties/westvirginia'
    import { wisconsinCountiesList } from '../counties/wisconsin'
    import { wyomingCountiesList } from '../counties/wyoming'


    export default {
        components: {
            Pagefooter,
        },
        data() {

            return {
                name: '',
                company: '',
                phone:"",
                contactname:"",
                zip:'',
                radius:'',
                street1:'',
                street2:'',
                state:'',
                county:'',
                email1:'',
                email2:'',
                email3:'',
                newEmail:'',
                newPassword:'',
                showSuccess: false,
                checkingAddress:false,
                selectedFile: null,
                fileExtension:'',
                addingLicense:false,
                description:'',
                abcLicenseNumber:'',
                validatedAddress:{},
                deliveryMethod:'', 
                otherDeliveryMethod:'',
                cloudinary: {
                    uploadPreset: 'vuelicenseupload',
                    thumbnailPreset: 'uploadthumbnail',
                    logoFullPreset:'logofullpreset',
                    logoThumbPreset:'logothumbpreset',
                    apiKey: '629997215451183',
                    cloudName: 'lo4xxr5lr',
                    uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
                }, 
                thumb: {
                    url: ''
                    },
                thumbs: [],
                loginForm:{
                    email:'',
                    password:'',
                },
                allowMarketingEmails:"no",
                allowOrderEmails: 'no',
                deliveryInstructions:'',
                userCountiesList: [],
                counties: [],

            }

        },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
            populateInitialValues(){
                this.email1 = this.userProfile.email1
                this.email2 = this.userProfile.email2
                this.email3 = this.userProfile.email3
                this.description = this.userProfile.description
                this.zip=this.userProfile.zip
                this.street1=this.userProfile.street1
                if(this.userProfile.street2) this.street2 = this.userProfile.street2
                this.company=this.userProfile.company
                this.phone=this.userProfile.phone
                this.contactname=this.userProfile.contactname
                
                //Constantly updated counties list for user
                this.userCountiesList = this.userProfile.counties
            },
            getCounties(){
                
                //var counties = []
                this.counties = []

                var theState = []
                if(this.currentUser) theState = this.userProfile.state
                //else theState = this.navigation.getParam("state")

                var allCounties = []
                if (theState == 'AL') allCounties = alabamaCountiesList
                if (theState == 'AK') allCounties = alaskaCountiesList
                if (theState == 'AZ') allCounties = arizonaCountiesList
                if (theState == 'AR') allCounties = arkansasCountiesList
                if (theState == 'CA') allCounties = californiaCountiesList
                if (theState == 'CO') allCounties = coloradoCountiesList
                if (theState == 'CT') allCounties = connecticutCountiesList
                if (theState == 'DE') allCounties = delawareCountiesList
                if (theState == 'FL') allCounties = floridaCountiesList
                if (theState == 'GA') allCounties = georgiaCountiesList
                if (theState == 'HI') allCounties = hawaiiCountiesList
                if (theState == 'ID') allCounties = idahoCountiesList
                if (theState == 'IL') allCounties = illinoisCountiesList
                if (theState == 'IN') allCounties = indianaCountiesList
                if (theState == 'IA') allCounties = iowaCountiesList
                if (theState == 'KS') allCounties = kansasCountiesList
                if (theState == 'KY') allCounties = kentuckyCountiesList
                if (theState == 'LA') allCounties = louisianaCountiesList
                if (theState == 'ME') allCounties = maineCountiesList
                if (theState == 'MD') allCounties = marylandCountiesList
                if (theState == 'MA') allCounties = massachussettsCountiesList
                if (theState == 'MI') allCounties = michiganCountiesList
                if (theState == 'MN') allCounties = minnesotaCountiesList
                if (theState == 'MS') allCounties = mississippiCountiesList
                if (theState == 'MO') allCounties = missouriCountiesList
                if (theState == 'MT') allCounties = montanaCountiesList
                if (theState == 'NE') allCounties = nebraskaCountiesList
                if (theState == 'NV') allCounties = nevadaCountiesList
                if (theState == 'NH') allCounties = newhampshireCountiesList
                if (theState == 'NJ') allCounties = newjerseyCountiesList
                if (theState == 'NM') allCounties = newmexicoCountiesList
                if (theState == 'NY') allCounties = newyorkCountiesList
                if (theState == 'NC') allCounties = northcarolinaCountiesList
                if (theState == 'ND') allCounties = northdakotaCountiesList
                if (theState == 'OH') allCounties = ohioCountiesList
                if (theState == 'OK') allCounties = oklahomaCountiesList
                if (theState == 'OR') allCounties = oregonCountiesList
                if (theState == 'PA') allCounties = pennsylvaniaCountiesList
                if (theState == 'RI') allCounties = rhodeislandCountiesList
                if (theState == 'SC') allCounties = southcarolinaCountiesList
                if (theState == 'SD') allCounties = southdakotaCountiesList
                if (theState == 'TN') allCounties = tennesseeCountiesList
                if (theState == 'TX') allCounties = texasCountiesList
                if (theState == 'UT') allCounties = utahCountiesList
                if (theState == 'VT') allCounties = vermontCountiesList
                if (theState == 'VA') allCounties = virgniaCountiesList
                if (theState == 'WA') allCounties = washingtonCountiesList
                if (theState == 'WV') allCounties = westvirginiaCountiesList
                if (theState == 'WI') allCounties = wisconsinCountiesList
                if (theState == 'WY') allCounties = wyomingCountiesList


                var arraySize = allCounties.length
                for (var i = 0; i<arraySize; i++){
                    var theCounty = {}
                    theCounty.name = allCounties[i]
                    var existingCountyindex = -1
                    if(this.userCountiesList ) existingCountyindex = this.userCountiesList.findIndex(item => item === theCounty.name);
                    if (existingCountyindex > -1){
                        theCounty.isSelected = true
                    } 
                    else theCounty.isSelected = false
                    
                    this.counties.push(theCounty)
                }
                return this.counties
            },

            checkName(){
                if (this.company.length<3) return false
                else return true
            },

            checkabcLicenseNumber(){
                if (this.abcLicenseNumber.length >3 ){
                    var isnum = /^\d+$/.test(this.abcLicenseNumber);
                    if(isnum) return true
                    else return false
                } 
                else return false

            },
            checkAddressLength(){
                if (this.street1.length<5) return false
                else return true
            },
            checkZipLength(){
                if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zip))
                    return true
                else return false
            },
            checkRadius(){
                if(isNaN(this.radius)) return false

                if (parseInt(this.radius)>=10)
                    return true
                else return false
            },

            returnEmailPrefs(){
                if(this.userProfile.sendOrderEmails == 1) this.allowOrderEmails='yes'
                if(this.userProfile.sendMarketingEmails == 1) this.allowMarketingEmails='yes'
                return
            },
            checkEmailValid(){
                 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.newEmail))
                    {
                        return (true)
                    }
                        return (false)
            },
            checkPasswordValid(){
                if (this.newPassword.length >=8) return true
                else return false
            },
            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },

            theDeliveryMethod(){
                if(this.deliveryMethod) return this.deliveryMethod
                else if(this.userProfile.isbrewer&&this.userProfile.deliveryMethod){
                    return this.userProfile.deliveryMethod
                }
                else return ""
            }

        },
        methods: {
            updateName(){
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            company:this.company, contactname:this.contactname, phone:this.phone
                        })
            },

            updateabcLicenseNumber(){
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            abcLicenseNumber:this.abcLicenseNumber
                        })

            },

            setDeliveryMethod(){
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            deliveryMethod:this.deliveryMethod
                        })

            },

            checkAddress(){
                //Check if address is valid
                if(!this.street2) this.street2 =''
                this.checkingAddress = true
                
                //Function to capitalize first letter of each word
                function titleCase(str) {
                    var splitStr = str.toLowerCase().split(' ');
                    for (var i = 0; i < splitStr.length; i++) {
                        // You do not need to check if i is larger than splitStr length, as your for does that for you
                        // Assign it back to the array
                        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
                    }
                    // Directly return the joined string
                    return splitStr.join(' '); 
                    }

                var correctedAddress = checkAddress(this.street1, this.street2, this.userProfile.city, this.zip, this.userProfile.state).then(response => {
                        console.log("In response")
                        this.checkingAddress = false
                        if (response=='ERROR'){
                            console.log("ERROR")
                            this.$bvModal.show("modal-invalidaddress")
                        } 
                        else {
                            console.log(response.data)
                            var newAddress = response.data
                            if(newAddress.status=="INVALID"){
                                this.$bvModal.show("modal-invalidaddress")
                                return
                            }

                            //New address found
                            else if (newAddress.status=="SUSPECT"){
                                this.validatedAddress.company = this.userProfile.company
                                this.validatedAddress.street1 = newAddress.addressline1
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = newAddress.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                this.validatedAddress.state= newAddress.state
                                this.validatedAddress.city = newAddress.city
                                this.validatedAddress.country = newAddress.country
                                this.validatedAddress.zip = newAddress.postalcode.substr(0, 5);
                                this.validatedAddress.county = titleCase(newAddress.county)
                                console.log("Updating address = ")
                                console.log(this.validatedAddress)
                                this.$bvModal.show("modal-newaddress")

                            }

                            //User entered a good address
                            else{
                                this.validatedAddress.company = this.userProfile.company
                                this.validatedAddress.street1 = newAddress.addressline1
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = newAddress.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                
                                this.validatedAddress.state= newAddress.state
                                this.validatedAddress.city = newAddress.city
                                this.validatedAddress.country = newAddress.country
                                this.validatedAddress.zip = newAddress.postalcode.substr(0, 5)
                                this.validatedAddress.county = titleCase(newAddress.county)
                                this.updateAddress()

                            }
                        }
                 })

            },
            
            //Update user address
            updateAddress(){
                this.showSuccess = true
                this.street1=this.validatedAddress.street1,
                this.street2=this.validatedAddress.street2,
                this.zip=this.validatedAddress.zip,
                this.county = this.validatedAddress.county
                    
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            street1:this.validatedAddress.street1,
                            street2:this.validatedAddress.street2,
                            zip:this.validatedAddress.zip,
                            county: this.validatedAddress.county,
                            state:this.validatedAddress.state,
                            country:this.validatedAddress.country,
                            city:this.validatedAddress.city
                        })
                    //If buyer, update address for all orders
                    var address = this.validatedAddress.street1
                    if(this.validatedAddress.street2) address = address + ', ' + this.validatedAddress.street2
                    address = address + ', ' + this.validatedAddress.city + ', ' + this.validatedAddress.state + ', ' + this.validatedAddress.zip
                    fb.ordersCollection.where('pubid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.ordersCollection.doc(doc.id).update({billingAddress:address, deliveryAddress:address})
                    })
                })

                //Reload user profile  
                this.$store.dispatch('fetchUserProfile')
            },

            //User clicked choose file for license
            onLicenseFileChanged (event) {
            
                if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
                return;
            }
            this.selectedFile = event.target.files[0]

            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);

            //outputfile.value = fileName;
            this.fileExtension = ext;
            this.uploadLicensetoCloudinary()

        },
            //User clicked choose file for logo
            onLogoFileChanged (event) {
                
                  if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
                    return;
                }
                this.selectedFile = event.target.files[0]
        
                const name = event.target.files[0].name;
                const lastDot = name.lastIndexOf('.');

                const fileName = name.substring(0, lastDot);
                const ext = name.substring(lastDot + 1);

                //outputfile.value = fileName;
                this.fileExtension = ext;
                this.uploadLogotoCloudinary()

            },

            //Upload license to Cloudinary
            uploadLicensetoCloudinary(){
                this.addingLicense = true
                let data = new FormData();
                data.append('name', this.currentUser.uid + '.' + this.fileExtension);
                data.append('file', this.selectedFile); 
                data.append('upload_preset', this.cloudinary.uploadPreset);

                axios
                    .post(this.cloudinary.uploadURL, data)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.usersCollection.doc(this.currentUser.uid).update({
                            licenseUploaded:1,
                            licenseFileURL:result.data.secure_url
                        })
                    }
                        this.addingLicense = false

                    })
                    .catch((err) => {
                        this.addingLicense = false
                    }) 

                let thumbdata = new FormData();
                thumbdata.append('name', this.currentUser.uid + '.' + this.fileExtension);
                thumbdata.append('file', this.selectedFile); 
                thumbdata.append('upload_preset', this.cloudinary.thumbnailPreset);

                //Add thumbnail
                axios
                    .post(this.cloudinary.uploadURL, thumbdata)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.usersCollection.doc(this.currentUser.uid).update({
                            licenseUploaded:1,
                            licenseFileThumbnailURL:result.data.secure_url
                        })
                        this.$bvToast.toast('Image Uploaded', {
                        title: 'Success!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                        }
                        this.addingLicense = false
                    })
                    .catch((err) => {
                        console.log('Ax Thumb Error:' + err);
                        this.addingLicense = false
                    })

            },
            //Upload logo to cloudinary
            uploadLogotoCloudinary(){
                this.addingLicense = true
                let data = new FormData();
                data.append('file', this.selectedFile); 
                data.append('upload_preset', this.cloudinary.logoFullPreset);

                axios
                    .post(this.cloudinary.uploadURL, data)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.usersCollection.doc(this.currentUser.uid).update({
                            logoUploaded:1,
                            logoFileURL:result.data.secure_url
                        })
                        }
                        this.$bvToast.toast('Image Uploaded', {
                        title: 'Success!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        this.addingLicense = false

                    })
                    .catch((err) => {
                        console.log('Ax Error:' + err);
                        this.addingLicense = false
                    }) 

                let thumbdata = new FormData();
                thumbdata.append('file', this.selectedFile); 
                thumbdata.append('upload_preset', this.cloudinary.logoThumbPreset);

                //Add thumbnail
                axios
                    .post(this.cloudinary.uploadURL, thumbdata)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.usersCollection.doc(this.currentUser.uid).update({
                            logoUploaded:1,
                            logoFileThumbnailURL:result.data.secure_url
                        })
                        }
                        this.addingLicense = false
                    })
                    .catch((err) => {
                        console.log('Ax Thumb Error:' + err);
                        this.addingLicense = false
                    })

            },

            updateRadius(){
                this.$store.dispatch('updateDeliveryZipCodesAsync', this.radius)
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
            },
            /*
            updateZip(){

                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)

                fb.usersCollection.doc(this.currentUser.uid).update({
                    zip:this.zip
                        })
                        if(this.userProfile.isbrewer){
                            //Update radius
                            this.$store.dispatch('updateDeliveryZipCodesWithNewZipAsync', this.zip)

                        }
                        else this.$store.dispatch('fetchUserProfile')
                        this.$bvToast.toast('Zip Code Updated', {
                            title: 'Keg Seeker',
                            solid:true,
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: false
                            })
            },
            */
            updateDescription(){
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            description:this.description
                        })

            },

            reAuthUser(redirectTo){

                if (redirectTo==0&&this.newEmail.toLowerCase()==this.currentUser.email.toLowerCase()){
                    this.$bvToast.toast("Old and new email addresses are the same", {
                        title: 'Did you enter a new email address?',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        return
                }
                

                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.theUserID = user.user.uid
                    if(redirectTo==0){
                        this.updateEmail()
                    }
                    if(redirectTo==1){
                        this.updatePassword()

                    }
                        
                }).catch(err => {
                    this.performingRequest = false
                    this.errorMsg = err.message
                        this.$bvToast.toast(err.message, {
                        title: 'Unable to login',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                    
                })

            },
            updateEmail(){
                if(this.newEmail==this.loginForm.email){
                        this.$bvToast.toast('Email update error', {
                        title: 'Old and new emails are the same',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        return
                }
                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.newEmail))){
                        this.$bvToast.toast('Please enter a valid new email', {
                        title: 'Invalid Email',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        return
                } 

                var user = firebase.auth().currentUser;
                user.updateEmail(this.newEmail).then(user => {
                 this.$bvToast.toast('Email Updated', {
                        title: 'Keg Seeker',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                        fb.usersCollection.doc(this.currentUser.uid).update({
                            email:this.newEmail
                        })


                }).catch(err => {
                    console.log(err)
                    this.errorMsg = err.message
                        this.$bvToast.toast(err.message, {
                        title: 'Error!',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                })
            },
            updatePassword(){
                if(this.newPassword.length<8){
                        this.$bvToast.toast('Password must be at least 8 character', {
                        title: 'Password too short!',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        return
                }

                else{

                    var user = firebase.auth().currentUser;

                    user.updatePassword(this.newPassword).then(user => {
                        this.$bvToast.toast('Password Updated', {
                        title: 'Keg Seeker',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                    }).catch(err => {
                    console.log(err)
                        this.errorMsg = err.message
                        this.$bvToast.toast(err.message, {
                        title: 'Error!',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                })

                }

            },
            updateEmailPreferences(){
                this.showSuccess=true
                //setTimeout(() => { this.showSuccess = false }, 1500)
                var sendOrderEmails = 0
                var sendMarketingEmails = 0

                if(this.allowOrderEmails=='yes'){
                    sendOrderEmails=1

                } 
                if(this.allowMarketingEmails=='yes') sendMarketingEmails=1

                fb.usersCollection.doc(this.currentUser.uid).update({
                    sendMarketingEmails:sendMarketingEmails,
                    sendOrderEmails: sendOrderEmails,
                }).then(() => {
                    this.showSuccess=false
                })
                
                this.$bvToast.toast('Email Preferences Updated', {
                        title: 'Keg Seeker',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 3000,
                        appendToast: false
                        })

            },
            updateInstructions(){
                console.log("Updating delivery instructions")
                this.showSuccess = true
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            deliveryInstructions:this.deliveryInstructions
                        })

            },
            updateAdditionalEmails(){
                console.log("Updating emails")
                this.showSuccess = true
                if(!this.email1) this.email1=""
                if(!this.email2) this.email2=""
                if(!this.email3) this.email3=""
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            email1:this.email1,
                            email2:this.email2,
                            email3:this.email3,
                        })
                

            },
            addToCountyList(countyName, index){
                console.log("Adding to counties " + countyName )
                this.userCountiesList.push(countyName)

            },
            removeCountyFromList(countyName){
                var existingCountyindex = this.userCountiesList.findIndex(item => item === countyName);
                if (existingCountyindex > -1){
                    this.userCountiesList.splice(existingCountyindex,1)
                    }

            },
            updateCounties(){
                fb.usersCollection.doc(this.currentUser.uid).update({
                    counties: this.userCountiesList
                        })
                //Update all user's beers to have this counties list
                fb.beersCollection.where('uid', '==', this.currentUser.uid).get().then(resp => {
                    console.log(resp.docs)
                    let batch = fb.db.batch();

                    resp.docs.forEach(userDocRef => {
                    batch.update(userDocRef.ref, {'counties': this.userCountiesList, state:this.userProfile.state });
                    })
                    batch.commit().catch(err => console.error(err));
                    
                }).catch(error => console.error(error))


            },

            //Change services offered
            changeServices(service, val){
                console.log("Updating services enabled for: " + service)
                console.log("Updating services enabled to: " + val)
                this.$bvToast.toast('This might take a minute', {
                        title: 'Updating Services',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                fb.usersCollection.doc(this.currentUser.uid).update({[service] : val});
            },

        },
    }
</script>
